module.exports = __webpack_public_path__ + "media/images/event_detail_test_image-ab18fd5eaf7f66d8847cd3d9c032af13.png";